import { createAction } from '@reduxjs/toolkit';

export const loaderClose = createAction(`session/loader/close`);
export const loaderOpen = createAction<string>(`session/loader/open`);
